module.exports = __webpack_public_path__ + "img/legal-expenses-icon.b386e6c6.svg";